module.exports = __webpack_public_path__ + "img/swiper1.c1f53f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/swiper1.png
// module id = 385
// module chunks = 0